import React from "react";

function ThreeStarThanks () {

return (
    <React.Fragment>
        <div className="text-center p-4 shadow-sm border" style={{backgroundColor: "white",fontFamily: "cambria"}}>
            <h3>Thank You for Your Feedback!</h3>
            <p>We appreciate your feedback. Your comments have been received.</p>
        </div>
    </React.Fragment>
);

}

export default ThreeStarThanks;